import React, { useState } from 'react';

import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core';
import { axiosInstance } from 'common/network';

const useStyles = makeStyles(() => ({
  // Keep the label on a single line and stop the toolbar's flex layout from squeezing it.
  trigger: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
}));

// Admin action: triggers a full re-projection of the analytics read model. The API only resets the
// projection watermark; the worker refreshes the rows in the background, so this returns immediately.
const RebuildReadModelButton = () => {
  const classes = useStyles();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [toastOpen, setToastOpen] = useState(false);

  const open = () => { setError(null); setConfirmOpen(true); };
  const close = () => { if (!submitting) setConfirmOpen(false); };

  const rebuild = () => {
    setSubmitting(true);
    setError(null);
    axiosInstance
      .post(process.env.REACT_APP_API_ROOT + 'v3/analytics/read-model/rebuild')
      .then(() => {
        setSubmitting(false);
        setConfirmOpen(false);
        setToastOpen(true);
      })
      .catch(() => {
        setSubmitting(false);
        setError('Could not start the rebuild. Please try again.');
      });
  };

  return (
    <>
      <Button className={classes.trigger} color="primary" size="small" variant="text" onClick={open}>
        Rebuild read model
      </Button>

      <Dialog open={confirmOpen} onClose={close}>
        <DialogTitle>Rebuild analytics read model?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This re-projects every analytics event and refreshes the table in the background. Rows stay
            visible throughout, but recent changes (e.g. account names) may take a little while to appear.
          </DialogContentText>
          {error && <DialogContentText color="error">{error}</DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button onClick={close} disabled={submitting}>Cancel</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={rebuild}
            disabled={submitting}
            startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
          >
            Rebuild
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => setToastOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <SnackbarContent message="Rebuild started. The table will refresh in the background." />
      </Snackbar>
    </>
  );
};

export default RebuildReadModelButton;
